/**
 * @fileoverview GET handler for the "/engagement/draganddrop_content_blocks" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementDragAndDropContentBlocks } from "./constants";
import type { DragAndDropContentBlocksResponse } from "./types";

export const getDragAndDropContentBlocks = reactQueryFetcherAdapter(
  engagementDragAndDropContentBlocks,
  (signal: AbortSignal): Promise<DragAndDropContentBlocksResponse> => {
    return fetch("/engagement/draganddrop_content_blocks", "GET", {}, { signal });
  }
);
